/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RequestMagicLinkBody
 */
export interface RequestMagicLinkBody {
    /**
     * 
     * @type {string}
     * @memberof RequestMagicLinkBody
     */
    destination?: string;
}

/**
 * Check if a given object implements the RequestMagicLinkBody interface.
 */
export function instanceOfRequestMagicLinkBody(value: object): value is RequestMagicLinkBody {
    return true;
}

export function RequestMagicLinkBodyFromJSON(json: any): RequestMagicLinkBody {
    return RequestMagicLinkBodyFromJSONTyped(json, false);
}

export function RequestMagicLinkBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): RequestMagicLinkBody {
    if (json == null) {
        return json;
    }
    return {
        
        'destination': json['destination'] == null ? undefined : json['destination'],
    };
}

export function RequestMagicLinkBodyToJSON(json: any): RequestMagicLinkBody {
    return RequestMagicLinkBodyToJSONTyped(json, false);
}

export function RequestMagicLinkBodyToJSONTyped(value?: RequestMagicLinkBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'destination': value['destination'],
    };
}

